import { useMemo } from "react";
import { useQueryInternalAccounts } from "../../../query/banking/queries/useQueryInternalAccounts";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../query/users/queries";
import { selectorIsTaxWithholdingsSetupComplete } from "../selectors/selectorIsTaxWithholdingsSetupComplete";

export function useIsTaxWithholdingsSetupComplete() {
  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);
  const queryInternalAccounts = useQueryInternalAccounts();

  return useMemo(
    () =>
      selectorIsTaxWithholdingsSetupComplete(
        queryMember.data,
        queryInternalAccounts.data
      ),
    [queryMember.data, queryInternalAccounts.data]
  );
}
